import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, MapPin, Newspaper } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import api from "@/lib/api";

export default function Blog() {
  const { data: posts = [], isLoading } = useQuery({
    queryKey: ["blog"],
    queryFn: async () => (await api.get("/blog")).data,
  });
  const cities = [...new Set(posts.map((p) => p.city))];
  const [city, setCity] = useState(null);
  const filtered = city ? posts.filter((p) => p.city === city) : posts;

  return (
    <PublicLayout>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1D9BF0]">Le blog Climateasy</p>
        <h1 className="mt-2 text-4xl font-extrabold text-[#263871] sm:text-5xl">Conseils clim, ville par ville</h1>
        <p className="mt-4 max-w-xl text-lg text-slate-600">Guides d'entretien, prix et astuces pour votre climatisation, près de chez vous.</p>

        {cities.length > 0 && (
          <div className="mt-8 flex flex-wrap gap-2">
            <button onClick={() => setCity(null)} className={`rounded-full px-4 py-1.5 text-sm font-medium ${!city ? "bg-[#263871] text-white" : "bg-slate-100 text-slate-600"}`}>Toutes</button>
            {cities.map((c) => (
              <button key={c} onClick={() => setCity(c)} className={`rounded-full px-4 py-1.5 text-sm font-medium ${city === c ? "bg-[#263871] text-white" : "bg-slate-100 text-slate-600"}`}>{c}</button>
            ))}
          </div>
        )}

        {isLoading ? (
          <p className="mt-12 text-slate-500">Chargement…</p>
        ) : filtered.length === 0 ? (
          <div className="mt-12 rounded-2xl border border-dashed border-slate-300 p-12 text-center text-slate-500">
            <Newspaper className="mx-auto h-10 w-10 text-slate-300" />
            <p className="mt-3">Les articles arrivent bientôt. Revenez vite !</p>
          </div>
        ) : (
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group flex flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-shadow hover:shadow-lg">
                <span className="flex items-center gap-1.5 text-xs font-semibold text-[#1D9BF0]"><MapPin className="h-3.5 w-3.5" />{p.city}</span>
                <h3 className="mt-3 flex-1 text-lg font-bold leading-snug text-[#263871]">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-500 line-clamp-2">{p.meta_description}</p>
                <span className="mt-4 flex items-center gap-1 text-sm font-semibold text-[#263871] group-hover:gap-2 transition-all">Lire <ArrowRight className="h-4 w-4" /></span>
              </Link>
            ))}
          </div>
        )}
      </section>
    </PublicLayout>
  );
}
